// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"638":"0bfa6604","685":"b18c670e","871":"8daef99f"}[chunkId] + ".css";
};